import * as api from '../../services/user'

export const FETCH_USERS= 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_LOGINED_USER = 'FETCH_LOGINED_USER';
export const FETCH_USERBUYVAS = 'FETCH_USERBUYVAS';
export const FETCH_USERQCOINTRANS = 'FETCH_USERQCOINTRANS';
export const FETCH_USERCASHTRANSTYPES = 'FETCH_USERCASHTRANSTYPES';


export const fetchUser = (id) => ({
    type: FETCH_USER,
    payload: {
        promise: api.findUser({id: id})
    }
});

export const fetchLoginedUser = (data={}) => ({
    type: FETCH_LOGINED_USER,
    payload: {
        promise: api.findUserDefault(data)
    }
});



export const fetchUsers = (params, pagination, sort, extra) => {

    return {
        type: FETCH_USERS,
        payload: {
            promise: api.findUsers(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchUserBuyVas = (params, pagination, sort, extra) => {

    return {
        type: FETCH_USERBUYVAS,
        payload: {
            promise: api.findUserBuyVas(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchUserQcoinTrans = (params, pagination, sort, extra) => {

    return {
        type: FETCH_USERQCOINTRANS,
        payload: {
            promise: api.findUserQcoinTrans(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchUserCashTransTypes = (params, pagination, sort, extra) => {

    return {
        type: FETCH_USERCASHTRANSTYPES,
        payload: {
            promise: api.findUserCashTransTypes(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/user.js